module.exports = __webpack_public_path__ + "img/9009a54.png";